import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import InputSelect from "../../common/InputSelect";
/*BootstrapTable anbd table Related*/
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

/*Loader */
import FadeIn from "react-fade-in";

/*animation*/
import Loader from "../../common/loader/Loader";
/*Inputs*/
/*Styles*/
import "./ProfileStraight.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function FinalStatsByAgent(props) {
  let curr = new Date();
  let week = [];

  for (let i = 1; i <= 7; i++) {
    let first = curr.getDate() - curr.getDay() + i;
    let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
    week.push(day);
  }

  const classes = useStyles();
  const [negatives, setNegatives] = React.useState([]);
  const [positives, setPositives] = React.useState([]);
  const [gameTypeID, setGameTypeID] = useState(1);
  const [gameType, setGameType] = useState();
  const [lineTypeID, setLineTypeID] = useState(1);
  const [lineType, setLineType] = useState();
  const [sportID, setSportID] = useState("CBB");
  const [sport, setSport] = useState();
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [isLoading, setIsLoading] = React.useState(true);
  const [playerType, setPlayerType] = useState(0);
  const [line, setLine] = useState(1);
  const [type, setType] = useState(0);
  const [range, setRange] = useState(0);
  const [juiceRebate, setJuiceRebate] = useState(0);

  const [groupByAgent, setGroupByAgent] = useState(false);
  // let IdPeriod = '0';

  const handleShow = () => { };

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/LineType/GetLineTypes";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let bookInfo = data.map((v) => {
          v.idLineType = v.idLineType ?? v.IdLineType;
          v.description = v.description ?? v.Description;
          return v;
        });
        setLineType(bookInfo);
      });
  }, [setLineType]);

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    const url = process.env.REACT_APP_API2_URL + "/Player/GetSports";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let officeInfo = data.map((v) => {
          v.idLineType = v.idSport ?? v.IdSport;
          v.description = v.sportName ?? v.SportName;
          return v;
        });
        setSport(officeInfo);
        setIsLoading(false);
      });
  }, [setSport]);

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    const url = process.env.REACT_APP_API2_URL + "/GameType/GameType_Get";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let officeInfo = data.map((v) => {
          v.idLineType = v.idGameType ?? v.IdGameType;
          v.description = v.description ?? v.Description;
          return v;
        });
        setGameType(officeInfo);
        setIsLoading(false);
      });
  }, [setGameType]);

  useEffect(() => {
    PositiveValues(lineTypeID, gameTypeID, sportID, line, type);
    NegativeValues(lineTypeID, gameTypeID, sportID, line, type);
  }, []);

  const PositiveValues = (
    lineTypeOnMem,
    gameTypeOnMem,
    sportOnMem,
    lineOnMem,
    typeOnMem
  ) => {
    setIsLoading(true);
    let request = {
      IdLineType: lineTypeOnMem,
      IdGameType: gameTypeOnMem,
      IdSport: sportOnMem,
      Line: lineOnMem,
      Online: typeOnMem,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL + "/Profile/JuiceRebate_GetListPositive",
      data: request,
    }).then((response) => {
      console.log("response", response.data);
      setPositives(response.data);
      setIsLoading(false);
    });
  };

  const NegativeValues = (
    lineTypeOnMem,
    gameTypeOnMem,
    sportOnMem,
    lineOnMem,
    typeOnMem
  ) => {
    setIsLoading(true);
    let request = {
      IdLineType: lineTypeOnMem,
      IdGameType: gameTypeOnMem,
      IdSport: sportOnMem,
      Line: lineOnMem,
      Online: typeOnMem,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL + "/Profile/JuiceRebate_GetListNegative",
      data: request,
    }).then((response) => {
      console.log("response", response.data);
      setNegatives(response.data);
      setIsLoading(false);
    });
  };
  // const [selectedIdGame, setselectedIdGame] = useState();

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
  };

  function onAfterDeleteRow(rowKeys) {
    let request = {
      IdLineType: lineTypeID,
      IdGameType: gameTypeID,
      IdSport: sportID,
      Line: line,
      Online: type,
      IdUser: userInfo.userId,
      Range: range,
      JuiceRebate: juiceRebate,
    };
    axios({
      method: "post",
      //url: process.env.REACT_APP_API2_URL + '/Profile/JuiceRebate_Delete',
      url: process.env.REACT_APP_API2_URL + "/Profile/JuiceRebate_Delete",
      data: request,
    }).then((response) => {
      if (response.data === 0) {
        PositiveValues(lineTypeID, gameTypeID, sportID, line, type);
        NegativeValues(lineTypeID, gameTypeID, sportID, line, type);
        alert("Data Successfully Deleted");
      }
    });
    //alert('The rowkey you drop: ' + rowKeys);
  }

  const handleTypeChange = (event) => {
    setType(event.target.value);
    PositiveValues(lineTypeID, gameTypeID, sportID, line, event.target.value);
    NegativeValues(lineTypeID, gameTypeID, sportID, line, event.target.value);
  };
  const handleLineChange = (event) => {
    setLine(event.target.value);
    PositiveValues(lineTypeID, gameTypeID, sportID, event.target.value, type);
    NegativeValues(lineTypeID, gameTypeID, sportID, event.target.value, type);
  };

  const cellEditProp = {
    mode: "click", //DBClick daba problemas con el Expand se cambio a click
    afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };
  function onAfterSaveCell(row, cellName, cellValue) {
    let request = {
      IdLineType: lineTypeID,
      IdGameType: gameTypeID,
      IdSport: sportID,
      Line: line,
      Online: type,
      IdUser: userInfo.userId,
      Range: row.range ?? row.Range,
      JuiceRebate: row.juiceRebate ?? row.JuiceRebate,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Profile/JuiceRebate_Update",
      data: request,
    }).then((response) => {
      if (response.data === 0) {
        //PositiveValues(lineTypeID, gameTypeID, sportID, line, type);
        //NegativeValues(lineTypeID, gameTypeID, sportID, line, type);
        alert("Data Successfully Updated");
      }
    });
    //alert('The rowkey you drop: ' + rowKeys);
  }
  /*Loader*/
  /**/

  function changeSportID(value) {
    setSportID(value);
    PositiveValues(lineTypeID, gameTypeID, value, line, type);
    NegativeValues(lineTypeID, gameTypeID, value, line, type);
  }

  function changeLineTypeID(value) {
    setLineTypeID(value);
    PositiveValues(value, gameTypeID, sportID, line, type);
    NegativeValues({ value }, gameTypeID, sportID, line, type);
  }
  function changeGameTypeID(value) {
    setGameTypeID(value);
    PositiveValues(lineTypeID, value, sportID, line, type);
    NegativeValues(lineTypeID, value, sportID, line, type);
  }

  function rowClassNameFormat(row, rowIdx) {
    // row is whole row object
    // rowIdx is index of row
    return rowIdx % 2 === 0
      ? "tr-function-example"
      : "td-column-function-odd-example";
  }
  function onRowSelect(row, isSelected, e) {
    setJuiceRebate(row.juiceRebate ?? row.JuiceRebate);
    setRange(row.range ?? row.Range);
  }

  const selectRowPropPositive = {
    mode: "checkbox",

    clickToSelect: true,
    onSelect: onRowSelect,
  };
  const selectRowPropNegative = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: onRowSelect,
  };
  return (
    <React.Fragment>
      <div class="main-div">
        {isLoading ? (
          <FadeIn>
            <div class="d-flex justify-content-center align-items-center">
              <Loader height={360} width={360} />
            </div>
          </FadeIn>
        ) : (
          ""
        )}
        <div className="flex flex-col gap-4">
          <form
            className={`${classes.container} flex flex-col gap-4`}
            noValidate
          >
            <div className="web-options">
              <InputSelect
                size="small"
                label="Line Type"
                variant="outlined"
                name="name"
                data={lineType}
                placeholder="Line Type"
                setSelectValue={changeLineTypeID}
                startValue={lineTypeID}
              />
              <InputSelect
                size="small"
                label="Game Type"
                variant="outlined"
                name="name"
                data={gameType}
                placeholder="Game Type"
                setSelectValue={changeGameTypeID}
                startValue={gameTypeID}
              />

              <InputSelect
                size="small"
                label="Sports"
                variant="outlined"
                name="name"
                data={sport}
                placeholder="Sports"
                setSelectValue={changeSportID}
                startValue={sportID}
              />
            </div>
            <div className="web-options">
              <b>Type</b>
              <div>
                <RadioGroup row>
                  <FormControlLabel
                    // value="None"
                    control={
                      <Radio
                        checked={type == "0"}
                        onChange={handleTypeChange}
                        value="0"
                        label="Local"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "None" }}
                      //disabled
                      />
                    }
                    label="Local"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    //   value="Home"
                    control={
                      <Radio
                        checked={type == "1"}
                        onChange={handleTypeChange}
                        value="1"
                        label="Online"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Home" }}
                      // disabled
                      />
                    }
                    label="Online"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </div>
            </div>
            <div className="web-options">
              <b>Line</b>
              <div>
                <RadioGroup row>
                  <FormControlLabel
                    // value="None"
                    control={
                      <Radio
                        checked={line == "1"}
                        onChange={handleLineChange}
                        value="1"
                        label="Spread"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "None" }}
                      //disabled
                      />
                    }
                    label="Spread"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    //   value="Home"
                    control={
                      <Radio
                        checked={line == "2"}
                        onChange={handleLineChange}
                        value="2"
                        label="Total"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Home" }}
                      // disabled
                      />
                    }
                    label="Total"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    //   value="Home"
                    control={
                      <Radio
                        checked={line == "3"}
                        onChange={handleLineChange}
                        value="3"
                        label="MoneyLine"
                        name="radio-button-time"
                        inputProps={{ "aria-label": "Home" }}
                      // disabled
                      />
                    }
                    label="Money Line"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </div>
            </div>
          </form>
          <div className="flex flex-col gap-4">
            <BootstrapTable
              data={positives}
              cellEdit={cellEditProp}
              deleteRow={true}
              options={options}
              insertRow={true}
              selectRow={selectRowPropPositive}
              trClassName={rowClassNameFormat}
            >
              <TableHeaderColumn hidden dataField="idLineType" isKey>
                Line Type
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="idGameType">
                Game Type
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="idSport">
                Sport
              </TableHeaderColumn>
              <TableHeaderColumn editable={false} dataField="range">
                Range
              </TableHeaderColumn>
              <TableHeaderColumn dataField="juiceRebate">
                Juice Rebate
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="line">
                Line
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="online">
                Online
              </TableHeaderColumn>
            </BootstrapTable>
            <BootstrapTable
              data={negatives}
              cellEdit={cellEditProp}
              deleteRow={true}
              options={options}
              selectRow={selectRowPropNegative}
              trClassName={rowClassNameFormat}
            >
              <TableHeaderColumn isKey={true} hidden dataField="idLineType">
                Line Type
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="idGameType">
                Game Type
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="idSport">
                Sport
              </TableHeaderColumn>
              <TableHeaderColumn editable={false} dataField="range">
                Range
              </TableHeaderColumn>
              <TableHeaderColumn dataField="juiceRebate">
                Juice Rebate
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="line">
                Line
              </TableHeaderColumn>
              <TableHeaderColumn hidden dataField="online">
                Online
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
